import sensors from '@/utils/sensors/sensors_config'
//注释部分只需服务端做
// 借款流程
export default {
    //序号23-Process-流程阶段
    $loanPro(process_name: any, partner_id: any, stage_name: any, if_success: any) {
        sensors.track('Process', {
            process_name,//	流程名称
            partner_id,//	合作方id
            stage_name,//	阶段名称
            if_success,//	是否成功
        })
    },
    // //序号24-BindCardResult-绑卡结果
    // $bcr(process_name: any, partner_id: any, if_success: any) {
    //     sensors.track('BindCardResult', {
    //         process_name,//	流程名称
    //         partner_id,//	合作方id
    //         if_success,//	是否成功
    //     })
    // },
    //序号25-LoanInitiation-借款发起
    // $loanInit(loan_amount: any, partner_id: any, if_success: any) {
    //     sensors.track('LoanInitiation', {
    //         loan_amount,//	借款金额
    //         partner_id,//	合作方id
    //         if_success,//	是否成功
    //     })
    // },
    //序号26-LoanResult-借款发起
    // $loanResult(loan_amount: any, partner_id: any, if_success: any,fail_reason:any) {
    //     sensors.track('LoanResult', {
    //         loan_amount,//	借款金额
    //         partner_id,//	合作方id
    //         if_success,//	是否成功
    //         fail_reason,//	失败原因
    //     })
    // },
}